"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveShippingOfferItemEvent = exports.Name = void 0;
const Name = exports.Name = 'remove-shipping-offer-item';
const RemoveShippingOfferItemEvent = exports.RemoveShippingOfferItemEvent = Name;
